import type { ChainConfig, Environment } from "../types";
import { CHAIN_REGISTRIES, DEFAULT_CHAIN_IDS } from "./chains";

export function cloneRegistries(): Record<Environment, Record<number, ChainConfig>> {
  return {
    mainnet: Object.fromEntries(
      Object.entries(CHAIN_REGISTRIES.mainnet).map(([chainId, config]) => [
        Number(chainId),
        { ...config, tokens: [...config.tokens] },
      ]),
    ),
    testnet: Object.fromEntries(
      Object.entries(CHAIN_REGISTRIES.testnet).map(([chainId, config]) => [
        Number(chainId),
        { ...config, tokens: [...config.tokens] },
      ]),
    ),
  };
}

export function getDefaultChainId(environment: Environment): number {
  return DEFAULT_CHAIN_IDS[environment];
}
